export default __webpack_public_path__ + "static/media/icons-meeting-link-enabled.d93dcbf1.svg";